<template>
  <div>
    <div
      class="inout-detail absolute_center"
      style="width: 1620px"
      :class="{
        _boxBg_green_secondLevel: styleType == 'typeGreen',
        _boxBg_dark_secondLevel: styleType == 'typeDark',
        _boxBg_blue_secondLevel:
          styleType == 'typeBlue' || styleType == 'typeStrong',
      }"
    >
      <div class="selfClose_btn" @click="close"></div>
      <div class="account">
        <div class="basic-info">
          <div class="basic-item">
            <label class="item-label">发动机号码：</label>
            <span>{{ info?.detail?.engineNumber }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">车辆识别代号(VIN)：</label>
            <span>{{ info?.detail?.vin }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">排放阶段：</label>
            <span>{{
              vehicleMissionsName[info?.detail?.vehicleEmissions] ?? ""
            }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">车队名称：</label>
            <span>{{ info?.detail?.owner }}</span>
          </div>
          <div class="basic-item">
            <label class="item-label">注册日期：</label>
            <span>{{
              info?.detail?.registrationDate
                ? info.detail.registrationDate.slice(0, 19)
                : ""
            }}</span>
          </div>
        </div>
        <div class="picture-info">
          <div
            class="picture-inner"
            @click="picture_click(item?.img)"
            v-for="(item, i) in pictureArr"
            :key="i"
          >
            <div class="picture" v-show="item && item.img ? item.img : false">
              <img :src="item?.img" />
            </div>
            <p v-show="item && item.img ? item.img : false">{{ item?.name }}</p>
          </div>
        </div>
        <div
          class="table_box"
          style="margin-top: 20px"
          v-if="(customerId == 63 && tableData.length > 0) || customerId == 59"
        >
          <el-table :data="tableData" style="width: 100%" height="100%">
            <el-table-column
              v-if="customerId === 59"
              prop="transportName"
              label="货物名称"
              align="center"
            >
              <template #default="scope">
                <span :title="scope.row.transportName">{{
                  scope.row.transportName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              prop="materialName"
              label="货物名称"
              align="center"
            >
              <template #default="scope">
                <span :title="scope.row.materialName">{{
                  scope.row.materialName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="customerId === 59"
              prop="transportVolume"
              label="货物重量(t)"
              align="center"
            >
              <template #default="scope">
                <span :title="scope.row.transportVolume">{{
                  scope.row.transportVolume
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              prop="materialWeight"
              label="货物重量(t)"
              align="center"
            >
              <template #default="scope">
                <span :title="scope.row.materialWeight">{{
                  scope.row.materialWeight
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="customerId === 59"
              prop="outTime"
              label="称重时间"
              align="center"
            >
              <template #default="scope">
                <span :title="scope.row.outTime">{{ scope.row.outTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-else
              prop="meatureTime"
              label="称重时间"
              align="center"
            >
              <template #default="scope">
                <span :title="scope.row.meatureTime">{{
                  scope.row.meatureTime
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { dateFormat, deteleObject } from "@/utils/tools.js";
import imgBox from "./components/imgBox.vue";
export default {
  name: "inoutDetail",
  props: [
    "globalInstance",
    "inOutTime",
    "numberPlate",
    "outTime",
    "inTime",
    "createTime",
  ],
  /*setup(props) {
    const inOutTime = props.inOutTime;
    const createTime = props.createTime;
    const numberPlate = props.numberPlate;
    const globalInstance = props.globalInstance;
    const outTime = props.outTime;
    const inTime = props.inTime;
    return { globalInstance, inOutTime, numberPlate, outTime, inTime, createTime };
  },*/
  data() {
    return {
      isNewCleanTransport: bmeConfig.isNewCleanTransport,
      customerId: this.globalInstance.$store.state.customerId,
      prefix: "",
      styleType: "",
      paramsImage: {
        inOutTime: "",
        numberPlate: "",
      },
      paramsDetail: {
        inTime: "",
        outTime: "",
        numberPlate: "",
      },
      info: {
        detail: {
          engineNumber: "",
          vin: "",
          vehicleEmissions: "",
          owner: "",
          registrationDate: "",
          drivingLicenseImage: "",
          onBoardList: "",
        },
        inOutImage: [{ inoutImage: "" }],
      },
      vehicleMissionsName: {
        3: "国III",
        4: "国IV",
        5: "国V",
        6: "国VI",
        99: "新能源",
        // 101: "铁路运输",
        // 102: "水路运输",
        // 103: "管道或管状带式输送机",
      },
      pictureArr: [
        {
          img: "",
          name: "进出厂识别",
        },
        {
          img: "",
          name: "行驶证",
        },
        {
          img: "",
          name: "随车清单",
        },
      ],
      tableData: [
        // {
        //   materialWeight: '312',
        //   materialName: '23',
        //   meatureTime: '312'
        // }
      ],
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent2: "getDialogCompontent2",
    }),
  },
  mounted() {
    this.getData();
  },
  created() {
    this.styleType = this.globalInstance.$store.state.styleType;
    if (this.customerId == 11) {
      this.vehicleMissionsName = {
        1: "国三",
        2: "国四",
        3: "国五",
        4: "国六",
        6: "国零",
        7: "国一",
        8: "国二",
        9: "国七",
        10: "电动",
        11: "无排放阶段",
      };
    }
  },
  watch: {
    numberPlate(newValue, oldValue) {
      this.getData();
    },
  },
  methods: {
    // 华乐门禁详情列表
    async hualeTableData() {
      const api =
        this.globalInstance.cleanTransportIp + "/ext/transport/inout_image";
      // const api =  "http://192.168.2.31:9112/bme-access-control/" + "/ext/transport/inout_image";
      this.paramsDetail = {
        customerId: this.customerId,
        inTime: this.inTime,
        outTime: this.outTime,
        numberPlate: this.numberPlate,
      };
      try {
        let res = await this.globalInstance.$apiUtils.get(
          api,
          this.paramsDetail
        );
        if (res.materialList && res.materialList.length) {
          res.materialList.forEach((r) => {
            if (!r.transportVolume) {
              r.transportVolume = "0";
            }
            r.outTime = dateFormat("YYYY-mm-dd HH:MM:SS", r.outTime);
          });
        }
        this.tableData = res.materialList ? res.materialList : [];
      } catch (err) {
        console.error(err);
      }
    },
    async getData() {
      if (this.customerId == 63) {
        this.paramsImage = {
          outTime: this.outTime,
          createTime: this.inTime,
          // inTime: this.inTime,
          numberPlate: this.numberPlate,
        };
      } else if (this.customerId == 59) {
        this.paramsImage = {
          inOutTime: this.inTime,
          numberPlate: this.numberPlate,
        };
      } else if (this.customerId == 89) {
        this.paramsImage = {
          inOutTime: this.inTime,
          numberPlate: this.numberPlate,
          createTime: this.createTime,
        };
      } else if (this.customerId == 90) {
        this.paramsImage = {
          createTime: this.createTime,
          numberPlate: this.numberPlate,
        };
      } else if (this.customerId == 92) {
        this.paramsImage = {
          createTime: this.createTime,
          numberPlate: this.numberPlate,
        };
      } else if (this.customerId == 81) {
        this.paramsImage = {
          createTime: this.inOutTime,
          numberPlate: this.numberPlate,
        };
      } else if (this.customerId == 54) {
        this.paramsImage = {
          createTime: this.createTime,
          numberPlate: this.numberPlate,
        };
      } else if (this.customerId == 72) {
        this.paramsImage = {
          createTime: this.createTime,
          numberPlate: this.numberPlate,
        };
      } else if (this.customerId == 94) {
        this.paramsImage = {
          createTime: this.inOutTime,
          numberPlate: this.numberPlate,
        };
      } else if (this.customerId == 58) {
        this.paramsImage = {
          createTime: this.inOutTime,
          numberPlate: this.numberPlate,
        };
      } else if (bmeConfig.isnewVesionTansDetail) {
        this.paramsImage = {
          createTime: this.createTime,
          numberPlate: this.numberPlate,
        };
      } else {
        this.paramsImage = {
          inOutTime: this.inOutTime,
          numberPlate: this.numberPlate,
        };
      }
      this.paramsImage.customerId = this.customerId;
      let url = this.globalInstance.cleanTransportIp + "/transport/inout_image";
      let res = await this.globalInstance.$apiUtils.get(url, this.paramsImage);
      this.info = res;
      this.tableData = res.materialList ? res.materialList : [];
      this.pictureArr[0].img = res?.inOutImage && res.inOutImage[0]?.inoutImage;
      this.pictureArr[1].img = res?.detail && res.detail?.drivingLicenseImage;
      this.pictureArr[2].img = res?.detail && res.detail?.onBoardList;
      if (this.customerId == 63) {
        this.pictureArr = [this.pictureArr[0], this.pictureArr[1]];
      }
      if (this.customerId == 23) {
        //新天钢
        this.pictureArr = [this.pictureArr[0], this.pictureArr[1]];
        this.pictureArr[1].name = "行驶证/随车清单";
      }
      if (this.customerId == 59) {
        this.hualeTableData();
      }
    },
    picture_click(url) {
      if (!url) return;
      this.globalInstance.$store.commit("dialogStatus2", true);
      this.globalInstance.$popup.open2(imgBox, this.dialogCompontent2, this, {
        imgurl: url,
      });
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
  },
};
</script>
<style lang="scss">
.inout-detail {
  .table_box {
    .el-table {
      background: transparent;
      border: 1px solid rgba(132, 170, 255, 0.5);
    }

    .el-table .el-table__header-wrapper .el-table__header .has-gutter {
      height: 50px;
      background: rgba(1, 18, 43, 0.81) !important;
      border: 1px solid rgba(132, 170, 255, 0.5);
    }

    .el-table thead {
      color: #909399;
      font-weight: 500;
    }

    .el-table td,
    .el-table th.is-leaf {
      border-bottom: 1px solid rgba(132, 170, 255, 0.5);
    }

    .el-table th.is-leaf {
      background: linear-gradient(
        180deg,
        rgba(108, 151, 255, 0.2) 0%,
        rgba(107, 151, 255, 0.2) 48%,
        rgba(58, 116, 255, 0.1) 100%,
        #0049fa 100%,
        #0049fa 100%
      ) !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.absolute_center {
  padding-top: 80px;
}

.account {
  width: 100%;
  height: 100%;
  padding: 70px 80px;
  padding-top: 0;
  font-size: 20px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
  }

  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background: #21a6e4;
  }

  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 8px;
    // background: #fff;
    width: 10px;
  }

  .table_box {
    background: transparent;
  }

  .basic-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .basic-item {
      width: 33.3%;
      height: 60px;
      line-height: 60px;
      color: white;

      .item-label {
        color: #a2d8ff;
      }
    }
  }

  .picture-info {
    margin-top: 140px;
    display: flex;
    justify-content: space-around;

    .picture-inner {
      width: 30%;

      p {
        color: #a2d8ff;
        font-size: 22px;
        line-height: 130px;
        text-align: center;
      }

      .picture {
        padding: 10px;
        width: 100%;
        height: 340px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        // background-image: url("../img/img_bg.png");
        position: relative;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }

        &:before {
          content: "";
          position: absolute;
          top: 20px;
          right: 20px;
          width: 54px;
          height: 54px;
          // background-image: url("./../img/enlarge.png");
        }
      }
    }
  }
}
</style>
